module.exports = __webpack_public_path__ + "media/images/brands/marque-shellac-91785b27f8bc3e53ba12aee9cfebe605.jpg";